const RecallWarningModal = (props) => {
  const {onClickReturn, selectedTimeSheet} = props;
  return (
    <>
      <div
        className="modal centered delete-modal fade"
        id="recallWarningModal"
        tabindex="-1"
        aria-labelledby="recallWarningModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered ">
          <div className="modal-content">
            <div className="modal-body" style={{ height: "unset" }}>
              <p
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "600",
                }}
              >
                Are you sure you want recall this timesheet ?
              </p>
            </div>
            <div className="modal-footer">
           
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-toggle="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary ok-btn"
                data-bs-toggle="modal"
                onClick={() => {
                  onClickReturn(selectedTimeSheet);
                }}
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RecallWarningModal;
